import Maybe from 'graphql/tsutils/Maybe';

import { NonNullableObject } from '@rbi-ctg/frontend';
import { ISanityTextNode } from '@rbi-ctg/menu';
import { IImageFragment } from 'generated/sanity-graphql';

export interface ILoyaltyTiersWidgetProps {
  title?: ISanityTextNode;
  /** Sanity controlled value that sorts by point value. Options: "asc" / "desc" */
  sortByPointValue: string;
}

export type NullableRewardTier = {
  image: Maybe<IImageFragment>;
  label: Maybe<string>;
  id: Maybe<string>;
  inactive: Maybe<boolean>;
};

export type RewardTier = NonNullableObject<NullableRewardTier>;

export interface ISortFunction {
  (a: RewardTier, b: RewardTier): number;
}

export enum Sort {
  Asc = 'asc',
  Desc = 'desc',
}

export interface ILoyaltyTierCardProps {
  /** Click handler for each tier */
  handleTierClick(data: RewardTier): void;
  /** index of the tier used for animation purposes  */
  idx: number;
  /** Data to populate each tier card */
  tier: RewardTier;
}
